import React from 'react';

import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';
import NotFoundPage from 'shared/ui/ErrorPage/NotFoundPage';
import {IPayment} from 'entities/payment';

import usePaymentFromQuery from '../../model/usePaymentFromQuery';

interface IPaymentResultScreenProps {
    pageTitle: string,
    Content: React.ComponentType<{item: IPayment}>,
}

const PaymentResultScreen: React.FC<IPaymentResultScreenProps> = ({pageTitle, Content}) => {
    const {payment, isLoading, isNotFound} = usePaymentFromQuery();

    if (isNotFound) {
        return <NotFoundPage/>;
    }

    return (
        <BlankLayout pageTitle={pageTitle} isLoading={isLoading}>
            {payment && <Content item={payment}/>}
        </BlankLayout>
    );
};

export default PaymentResultScreen;
